export const examesProps = {
  basename: "/plataforma/exames",
};
